import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { hasLodgingForPackage, getRVDetails } from '../../../util/package';

const usePackageBadges = (packageInfo, overrideInfo = null, listing = null) => {
  return useMemo(() => {
    if (!packageInfo) return [];

    const badges = [];

    const { days, guests } = packageInfo;

    // Get RV details from listing and package info
    const { isRvFriendly: originalIsRvFriendly, hasRVSites: originalHasRVSites } = listing
      ? getRVDetails(listing, packageInfo)
      : { isRvFriendly: packageInfo.isRvFriendly, hasRVSites: packageInfo.hasRVSites };

    let newHasRVSites = originalHasRVSites;
    let newIsRvFriendly = originalIsRvFriendly;
    const newDays = { ...days };
    const newGuests = { ...guests };

    let hasLodging = hasLodgingForPackage(packageInfo);

    // Apply overrides
    if (overrideInfo?.hasLodging) {
      hasLodging = overrideInfo.hasLodging;
    }

    if (overrideInfo?.days?.min) {
      newDays.min = overrideInfo.days.min;
    }

    if (overrideInfo?.guests?.min !== undefined) {
      newGuests.min = overrideInfo.guests.min;
    }

    if (overrideInfo?.guests?.max !== undefined) {
      newGuests.max = overrideInfo.guests.max;
    }

    if (overrideInfo?.isRvFriendly) {
      newIsRvFriendly = overrideInfo.isRvFriendly;
    }

    if (overrideInfo?.hasRVSites) {
      newHasRVSites = overrideInfo.hasRVSites;
    }

    // Calculate effective min guests for display (1 if min is 0)
    const effectiveMinGuests = newGuests?.min === 0 ? 1 : newGuests?.min;
    const shouldShowGuestsBadge = effectiveMinGuests !== undefined && effectiveMinGuests !== null;

    // Add guests badge
    if (shouldShowGuestsBadge) {
      badges.push({
        label: <FormattedMessage id="PackageCard.guests" values={{ count: effectiveMinGuests }} />,
        variant: 'User',
      });
    }

    // Add days badge
    if (newDays?.min) {
      badges.push({
        label: <FormattedMessage id="PackageCard.days" values={{ count: newDays.min }} />,
        variant: 'Calendar',
      });
    }

    // Add lodging badge
    if (hasLodging) {
      badges.push({
        label: <FormattedMessage id="PackageCard.lodging" />,
        variant: 'Lodge',
      });
    }

    // Add RV friendly badge
    if (newIsRvFriendly && !newHasRVSites) {
      badges.push({
        label: <FormattedMessage id="PackageCard.rvFriendly" />,
        variant: 'CaravanSimple',
      });
    }

    // Add RV sites badge
    if (newHasRVSites) {
      badges.push({
        label: <FormattedMessage id="PackageCard.rvSites" />,
        variant: 'CaravanSimple',
      });
    }

    return badges;
  }, [packageInfo, overrideInfo, listing]);
};

export default usePackageBadges;
